import { render, staticRenderFns } from "./ExerciseSection.vue?vue&type=template&id=2fb856b0&"
import script from "./ExerciseSection.vue?vue&type=script&lang=js&"
export * from "./ExerciseSection.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports